// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__HYf5k","ant-page-header-heading-title":"styles_ant-page-header-heading-title__6YjkS","table":"styles_table__Gyqyg"};